import { FC } from 'react';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
export const ActivityDayHeaderSkeleton: FC = () => {
    return <ThemedSkeleton variant="text" width={100} height={18} />;
};
